import React from 'react';
import { Box, Container, HStack, Skeleton, SkeletonText, VStack, VisuallyHidden } from '@chakra-ui/react';
import { HERO_DIMENSIONS } from '@/components/hero';
import { cardSurfaceProps } from '@/styles/cardSurface';


/**
 * Route-level pending UI for the restaurant profile (shown by the router only
 * when the loader is still running after `pendingMs`, e.g. a deep link or a tap
 * with no list data to seed from). Mirrors the real page's silhouette: hero
 * block at `HERO_DIMENSIONS`, the Check In / Rate / Save / Share row, then
 * card-surface rows, so the swap to real content does not shift layout.
 */
export const RestaurantProfileSkeleton: React.FC = () => (
  <Box w="100%" aria-busy="true" data-testid="restaurant-profile-skeleton">
    <VisuallyHidden role="status">Loading restaurant</VisuallyHidden>
    <Skeleton
      height={HERO_DIMENSIONS.height}
      width="100%"
      startColor="gray.200"
      endColor="gray.300"
    />
    <Container maxW="container.xl" px={{ base: 4, lg: 6 }} py={6}>
      <HStack spacing={3} mb={6}>
        {[0, 1, 2, 3].map((i) => (
          <Skeleton key={i} flex={1} height="44px" borderRadius="var(--r-card)" startColor="gray.200" endColor="gray.300" />
        ))}
      </HStack>
      <VStack align="stretch" spacing={3}>
        {[0, 1, 2].map((i) => (
          <Box key={i} {...cardSurfaceProps} p={{ base: 3, lg: 6 }}>
            <Skeleton height="20px" width="40%" mb={4} startColor="gray.200" endColor="gray.300" />
            <SkeletonText noOfLines={3} spacing={3} startColor="gray.200" endColor="gray.300" />
          </Box>
        ))}
      </VStack>
    </Container>
  </Box>
);
